import { createContext, useContext, useState } from "react";

const AccountContext=createContext()

export function AccountProvider({children}) {
    
    const [address,setAddress]=useState("")
    const [connected, toggleConnect] = useState(false);


    async function connectWebsite() {

        if (!window.ethereum) return window.open('https://metamask.io/download/', '_blank');
        const chainId = await window.ethereum.request({ method: 'eth_chainId'});
        try {
          if (chainId !== process.env.REACT_APP_CHAIN_ID) {
            await window.ethereum.request({
              method: 'wallet_switchEthereumChain',
              params: [{ chainId: process.env.REACT_APP_CHAIN_ID }],
            });
          }
        } catch (error) {
          if (error.code===4902) {
            
            await window.ethereum.request({
              method: 'wallet_addEthereumChain',
              params: [
                {
                  chainId: process.env.REACT_APP_CHAIN_ID,
                  chainName: 'Ethereum Mainnet',
                  rpcUrls: [process.env.REACT_APP_PROVIDER_URL],
                  nativeCurrency: {
                    name: 'Ether',
                    symbol: 'ETH',
                    decimals: 18
                  },
                  blockExplorerUrls: ['https://etherscan.io']
                }
              ],
            });
          }
        }
          
    
        const address=await window.ethereum.request({ method: 'eth_requestAccounts' })
        if (address.length>0) {
          setAddress(address[0])
          toggleConnect(true)
          localStorage.setItem("connect",true)
          localStorage.setItem("address",address[0])
        }
      }

    return(
        <AccountContext.Provider value={{address,setAddress,connected,toggleConnect,connectWebsite}}>
            {children}
        </AccountContext.Provider>
    )
}

export function   useAddress() {
    
    const {address,setAddress,connected,toggleConnect,connectWebsite}=useContext(AccountContext)

    return {address,setAddress,connected,toggleConnect,connectWebsite}
}